module.exports = __webpack_public_path__ + "imgs/HighCoolCat.5060de29dedb20177a0a1f9f2a7e566c.png";